import { render, staticRenderFns } from "./VxList.vue?vue&type=template&id=776bedb6"
import script from "./VxList.vue?vue&type=script&lang=js"
export * from "./VxList.vue?vue&type=script&lang=js"
import style0 from "./VxList.vue?vue&type=style&index=0&id=776bedb6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.18.1_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.112.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2631297424/src/github.com/FebosIO/Febos-AMI/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776bedb6')) {
      api.createRecord('776bedb6', component.options)
    } else {
      api.reload('776bedb6', component.options)
    }
    module.hot.accept("./VxList.vue?vue&type=template&id=776bedb6", function () {
      api.rerender('776bedb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vx-list/VxList.vue"
export default component.exports